module.exports = __webpack_public_path__ + "static/media/raven_full.46a6e929.png";